module.exports = __webpack_public_path__ + "static/media/simple-auto-refresher.2d849b81.jpg";